import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ContentLoader } from '@saucelabs/sl-component-loader';
import NotificationsContainer from '@saucelabs/sl-container-notifications';
import ErrorPagesContainer from '@saucelabs/sl-container-error-pages';
import { records as userRecords } from '@saucelabs/sl-module-user';

import * as operations from './../operations';
import Styles from './ApplicationContainer.styles';
import AccountExpiredContainer from '../../account-expired/containers/AccountExpiredContainer';


const ErrorPagesWithRouter = withRouter(ErrorPagesContainer);
class Application extends Component {
  componentDidMount() {
    const { initialize, postInitialize } = this.props;
    initialize().then(() => {
      postInitialize();
    });
  }

  componentWillUnmount() {
    const { stop } = this.props;
    stop();
  }

  renderContent() {
    const {
      children,
      initialized,
      user,
      unauthenticated,
    } = this.props;

    if (!unauthenticated && initialized && user && !user.get('verified')) {
      return <Redirect to={{ pathname: '/verify-email' }} />;
    }

    return (
      <div className={Styles.content}>
        <Helmet
          defaultTitle="Sauce Labs"
          titleTemplate="Sauce Labs | %s"
        />
        <NotificationsContainer />
        <ErrorPagesWithRouter>
          <AccountExpiredContainer />
          {children}
        </ErrorPagesWithRouter>
      </div>
    );
  }

  render() {
    const { initialized, user, errorCode } = this.props;
    const appInitialized = initialized && user;

    return (
      <ContentLoader show={!appInitialized && !errorCode}>
        {this.renderContent()}
      </ContentLoader>
    );
  }
}

Application.defaultProps = {
  errorCode: undefined,
  user: null,
};

Application.propTypes = {
  children: PropTypes.node.isRequired,
  errorCode: PropTypes.number,
  initialize: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  postInitialize: PropTypes.func.isRequired,
  stop: PropTypes.func.isRequired,
  unauthenticated: PropTypes.bool.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass),
};

const mapStateToProps = ({ apps: { app }, user, errorPage }) => ({
  errorCode: errorPage.status,
  initialized: app.get('initialized'),
  unauthenticated: app.get('unauthenticated'),
  user,
});

const mapDispatchToProps = {
  initialize: operations.initialize,
  postInitialize: operations.postInitialize,
  stop: operations.stop,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Application));
export { Application, mapStateToProps, mapDispatchToProps };
